// captcha.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private captchaCode: string;

  constructor() {
    this.generateCaptcha();
  }

  generateCaptcha() {
    // const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const chars = '0123456789';
    this.captchaCode = '';
    for (let i = 0; i < 6; i++) {
      this.captchaCode += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  }

  getCaptchaCode(): string {
    return this.captchaCode;
  }

  validateCaptcha(input: string): boolean {
    return input === this.captchaCode;
  }
}
